<template>
    <b-modal
        id="deadline-add-deadline-modal"
        :title="$t('deadline.new_deadline')"
        @ok="onOk"
        @show="onShow"
        modal-class="apprentice-default-modal"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        :ok-title="$t('common.save')">
        <b-form-group
            label="Type:"
            label-for="type">
            <div v-if="typeError">
                <b-alert
                    show
                    variant="danger"
                    >{{ $t('deadlines.type_mandatory') }}</b-alert
                >
            </div>
            <design-2021-apprentice-multiselect-component
                id="add-deadline-select"
                v-model="type"
                :multiple-select="false"
                :options="options"
                label="name"></design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            label="Deadline:"
            label-for="delivery_date">
            <div v-if="deadlineError">
                <b-alert
                    show
                    variant="danger"
                    >{{ $t('deadlines.deadline_mandatory') }}</b-alert
                >
            </div>

            <b-form-datepicker
                class="apprentice-date-picker btn-date-group"
                v-model="deadline"
                today-button
                reset-button
                right
                locale="nl"
                start-weekday="1"
                today-variant="primary"
                nav-button-variant="primary"
                :aria-controls="$t('deadline.choose_start_date')"
                label-reset-button="reset"
                label-no-date-selected="Deadline"
                :label-current-month="$t('deadline.this_month')"
                :label-today-button="$t('deadline.today')"
                menu-class="datedropdown"
                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
            </b-form-datepicker>

            <div v-if="timeError">
                <b-alert
                    show
                    variant="danger"
                    >{{ $t('deadlines.time_mandatory') }}</b-alert
                >
            </div>

            <design-2021-apprentice-timepicker-component v-model="time"></design-2021-apprentice-timepicker-component>
        </b-form-group>

        <b-form-group
            :label="$t('deadline.delivery_date') + ':'"
            label-for="delivery_date">
            <div v-if="deliveryError">
                <b-alert
                    show
                    variant="danger"
                    >{{ $t('deadlines.delivery_date_mandatory') }}</b-alert
                >
            </div>

            <b-form-datepicker
                class="apprentice-date-picker btn-date-group"
                v-model="delivery_date"
                today-button
                reset-button
                right
                locale="nl"
                start-weekday="1"
                today-variant="primary"
                nav-button-variant="primary"
                :aria-controls="$t('deadline.choose_start_date')"
                label-reset-button="reset"
                :label-no-date-selected="$t('deadline.delivery_date')"
                :label-current-month="$t('deadline.this_month')"
                :label-today-button="$t('deadline.today')"
                menu-class="datedropdown"
                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
            </b-form-datepicker>
        </b-form-group>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-deadlines-index-add-deadline-modal-component',
    data() {
        return {
            options: [
                {
                    name: this.$t('deadline.school_paper'),
                    value: 1,
                },
                {
                    name: this.$t('deadline.yearbook'),
                    value: 2,
                },
                {
                    name: this.$t('deadline.farewell_booklet'),
                    value: 4,
                },
            ],
            type: 1,
            delivery_date: null,
            deadline: null,
            time: null,
            typeError: false,
            deliveryError: false,
            deadlineError: false,
            timeError: false,
        };
    },
    methods: {
        onShow() {
            this.type = 1;
            this.delivery_date = null;
            this.deadline = null;
            this.time = null;
            this.typeError = false;
            this.deliveryError = false;
            this.deadlineError = false;
            this.timeError = false;
        },

        onOk(event) {
            this.typeError = !this.type || !this.type.value;
            this.deliveryError = !this.delivery_date;
            this.deadlineError = !this.deadline;
            this.timeError = !this.time;

            if (this.typeError || this.deliveryError || this.deadlineError || this.timeError) {
                event.preventDefault();
            } else {
                let data = {
                    type_id: this.type.value,
                    delivery_date: this.delivery_date,
                    deadline: this.deadline,
                    time: this.time,
                };

                this.alert.saving();

                this.axios.post(this.routes.deadline(), data).then(
                    (response) => {
                        ords.use('deadline').add(response.data);

                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
    },
};
</script>

<style scoped></style>
